/**
 * Template Loader
 * Product Selector Quote Form
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'templates';
const log = debug(MODULE_NAME);


//
// Dependencies
import { WORD_SELECTOR_TEMPLATE_SELECTOR } from './config';
import { loadTemplate } from '@core/services/template-loader';

/**
 * Get the Word Selector Template
 * @returns {String}
 */
export function wordSelectorTemplate (context) {
	log('Fetching wordSelectorTemplate');
	return loadTemplate(WORD_SELECTOR_TEMPLATE_SELECTOR, context);
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/templates.js